"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TectonicStakingPoolFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldRewardRatio",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newRewardRatio",
                type: "uint256",
            },
        ],
        name: "CallerRewardChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address[][]",
                name: "paths",
                type: "address[][]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "errorCodes",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tonicAmount",
                type: "uint256",
            },
        ],
        name: "ConversionsPerformed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldCooldown",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newCooldown",
                type: "uint256",
            },
        ],
        name: "CooldownChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "newExchangeRate",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        name: "ExchangeRateUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldImplementation",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "ImplementationChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "TokenDeregistered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "TokenRegistered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "xTonicBurned",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tonicReleased",
                type: "uint256",
            },
        ],
        name: "TonicReleased",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tonicStaked",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "xTonicMinted",
                type: "uint256",
            },
        ],
        name: "TonicStaked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "xTonicLocked",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "releasableBlockNum",
                type: "uint256",
            },
        ],
        name: "TonicUnstaked",
        type: "event",
    },
    {
        stateMutability: "nonpayable",
        type: "fallback",
    },
    {
        inputs: [],
        name: "_cooldownPeriod",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "_tonic",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "_xTonic",
        outputs: [
            {
                internalType: "contract xTonic",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "callerRewardBase",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "callerRewardRatio",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "contribute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
        ],
        name: "deregisterToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "dstAddress",
                type: "address",
            },
        ],
        name: "emergencyPull",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "enableTcmConvertPublicAccess",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "exchangeRateBase",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "getCooldownBlockNum",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "getCooldownTokens",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getExchangeRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "getReleasableTokens",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "xTonicAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "tonicAddress",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "cooldownPeriod",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "tcmImplementation",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "callerRewardRatio",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[][]",
                name: "_paths",
                type: "address[][]",
            },
            {
                internalType: "uint256[]",
                name: "_amounts",
                type: "uint256[]",
            },
        ],
        name: "performConversionForTokens",
        outputs: [
            {
                internalType: "uint256[]",
                name: "errorCodes",
                type: "uint256[]",
            },
            {
                internalType: "uint256",
                name: "tonicAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "minTonicAmount",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[][]",
                name: "_paths",
                type: "address[][]",
            },
        ],
        name: "performConversionForTokensFullBalance",
        outputs: [
            {
                internalType: "uint256[]",
                name: "errorCodes",
                type: "uint256[]",
            },
            {
                internalType: "uint256",
                name: "tonicAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "minTonicAmount",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
        ],
        name: "registerToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_tokens",
                type: "address[]",
            },
        ],
        name: "registerTokens",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "release",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_callerRewardRatio",
                type: "uint256",
            },
        ],
        name: "setCallerRewardRatio",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "newCooldownPeriod",
                type: "uint32",
            },
        ],
        name: "setCooldownPeriod",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_tcmImplementation",
                type: "address",
            },
        ],
        name: "setTcmImplementation",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "stake",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "tcmImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tcmPublicAccess",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "unstake",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
class TectonicStakingPoolFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TectonicStakingPoolFactory = TectonicStakingPoolFactory;
TectonicStakingPoolFactory.bytecode = _bytecode;
TectonicStakingPoolFactory.abi = _abi;
//# sourceMappingURL=TectonicStakingPoolFactory.js.map